import { DebtToIncomeCalculator } from "../Apps/DebtToIncomeCalculator"

function AppDebtToIncomeCalculator() {

  return (
    <DebtToIncomeCalculator />
  )
}

export default AppDebtToIncomeCalculator

